import { render } from "./Selectbox.vue?vue&type=template&id=0f36234e&scoped=true"
import script from "./Selectbox.vue?vue&type=script&lang=js"
export * from "./Selectbox.vue?vue&type=script&lang=js"

import "./Selectbox.vue?vue&type=style&index=0&id=0f36234e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-0f36234e"

export default script